import React, { FC, useState, useEffect, useRef } from 'react';

interface IDragAndDrop {
    id: string;
    name: string;
    label: string;
    error: string;
    formData: any;
    setFormData: (state: any) => void;
    setFormErrors: (state: any) => void;
    isFormDataCleared: boolean;
}

const DragAndDrop: FC<IDragAndDrop> = ({ id, name, label, formData, setFormData, error, setFormErrors, isFormDataCleared }: IDragAndDrop) => {

    const dragAndDropRef = useRef<HTMLInputElement>(null);

    const [ drag, setDrag ] = useState<boolean>(false);

    const [ chosenFiles, setChosenFiles ] = useState<any[] | null>([]);

    const onDragHandler = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setDrag(true);
    };

    const onDragLeaveHandler = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setDrag(false);
    };

    const onDropHandler = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();

        if (event.dataTransfer.files.length > 3) {
            setFormErrors((state: any) => {
                return {
                    ...state,
                    [name]: 'Up to 3 files allowed'
                }
            });
            return;
        } else {
            setFormErrors((state: any) => {
                return {
                    ...state,
                    [name]: ''
                }
            });
        }

        // @ts-ignore
        // dispatch(BlacklistActions.addNewFile([...event.dataTransfer.files], companyToEditId));
        setChosenFiles([...event.dataTransfer.files]);


        setFormData((state: any) => {
            return {
                ...state,
                // @ts-ignore
                [name]: [...state[name], ...event.dataTransfer.files],
            }
        });

        setFormErrors && setFormErrors((state: any) => {
            return {
                ...state,
                [name]: ''
            }
        });

        setDrag(false);
    };

    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();

        // @ts-ignore
        setChosenFiles([...event.target.files]);

        setFormData((state: any) => {
            return {
                ...state,
                // @ts-ignore
                [name]: [...state[name], ...event.target.files],
            }
        });

        setFormErrors && setFormErrors((state: any) => {
            return {
                ...state,
                [name]: ''
            }
        });
    };

    useEffect(() => {
        if (!formData[name].length) {

            const input = dragAndDropRef.current;
            if (input) {
                input.value = '';
            }

            setChosenFiles([]);
        }

    }, [isFormDataCleared]);

    return (
        <div className="drag-and-drop">
            {drag
                ?
                <>
                    <div
                        className={`drag-and-drop__drop-area ${error ? 'error' : ''}`}
                        onDragStart={onDragHandler}
                        onDragLeave={onDragLeaveHandler}
                        onDragOver={onDragHandler}
                        onDrop={onDropHandler}
                    >
                        <img
                            className="drag-and-drop__icon-upload"
                            src="/images/pages/Resources/Blacklist/icon_upload.svg"
                            alt="upload"
                        />
                        <span className="drag-and-drop__drop-area-text">Release to upload</span>
                    </div>
                    {error
                        ?
                        <p className="drag-and-drop__error">{error}</p>
                        :
                        <></>
                    }
                </>
                :
                <>
                    <div
                        className="drag-and-drop__drop-area"
                        onDragStart={onDragHandler}
                        onDragLeave={onDragLeaveHandler}
                        onDragOver={onDragHandler}
                        onDrop={onDropHandler}
                    >
                        <img
                            className="drag-and-drop__icon-upload"
                            src="/images/pages/Resources/Blacklist/icon_upload.svg"
                            alt="upload"
                        />
                        <span className="drag-and-drop__drop-area-text">Drag one or multiple documents</span>
                    </div>
                    {error
                        ?
                        <p className="drag-and-drop__error">{error}</p>
                        :
                        <></>
                    }
                </>
            }
            <p>
                or
            </p>
            <div className="drag-and-drop__input-box">
                <label
                    className="drag-and-drop__input-label"
                    htmlFor={id}
                >
                    {label}
                    <input
                        className="drag-and-drop__input"
                        ref={dragAndDropRef}
                        type="file"
                        id={id}
                        onChange={onChangeHandler}
                        multiple
                    />
                </label>
                {
                    chosenFiles?.map((item: any, index: number) => {
                        return (
                            <p
                                className="drag-and-drop__file-item"
                                key={`${item}_${index}`}
                            >
                                {item.name}
                            </p>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default React.memo(DragAndDrop);
